export const appealStatusLabels = {
    submitted: 'ثبت‌شده',
    under_review: 'در حال بررسی',
    accepted: 'پذیرفته‌شده',
    partially_accepted: 'تاحدی پذیرفته‌شده',
    rejected: 'ردشده',
    withdrawn: 'منصرف‌شده',
};

export const appealReasonLabels = {
    grading_error: 'خطای تصحیح',
    missing_answer: 'پاسخ لحاظ‌نشده',
    incorrect_key: 'کلید پاسخ نادرست',
    technical_issue: 'مشکل فنی',
    other: 'سایر',
};

export const feedbackCategoryLabels = {
    accuracy: 'دقت',
    explanation: 'توضیحات',
    speed: 'سرعت',
    usability: 'سهولت استفاده',
    other: 'سایر',
};

export const feedbackScopeLabels = {
    result: 'نتیجه آزمون',
    grading: 'تصحیح',
    process: 'فرایند آزمون',
    question: 'سؤال',
};

export const appealScopeLabels = {
    overall_result: 'نتیجه کلی',
    answer: 'پاسخ سؤال',
};

export const eligibilityReasonLabels = {
    APPEALS_DISABLED: 'ثبت اعتراض برای این آزمون غیرفعال است.',
    RESULTS_NOT_RELEASED: 'نتیجه آزمون هنوز منتشر نشده است.',
    OVERALL_APPEALS_DISABLED: 'اعتراض به نتیجه کلی این آزمون مجاز نیست.',
    QUESTION_APPEALS_DISABLED: 'اعتراض به سؤال‌های این آزمون مجاز نیست.',
    APPEAL_WINDOW_CLOSED: 'مهلت ثبت اعتراض پایان یافته است.',
    OPEN_APPEAL_LIMIT_REACHED: 'سقف اعتراض‌های باز این تلاش تکمیل شده است.',
    OPEN_APPEAL_ALREADY_EXISTS: 'برای این مورد یک اعتراض باز وجود دارد.',
};

export const appealEventLabels = {
    created: 'اعتراض ثبت شد',
    review_started: 'بررسی آغاز شد',
    status_changed: 'وضعیت تغییر کرد',
    grade_changed: 'نمره تغییر کرد',
    withdrawn: 'دانشجو منصرف شد',
};

export const formatFeedbackDate = (value) => value
    ? new Intl.DateTimeFormat('fa-IR', {dateStyle: 'medium', timeStyle: 'short'}).format(new Date(value))
    : '—';

export const feedbackEditDeadline = (createdAt) => {
    const created = new Date(createdAt).getTime();
    return Number.isFinite(created) ? new Date(created + 24 * 60 * 60 * 1000) : null;
};

export const canEditFeedback = (feedback, now = Date.now()) => {
    const deadline = feedbackEditDeadline(feedback?.created_at);
    return Boolean(deadline && deadline.getTime() > now);
};

export const formatRemainingTime = (deadline, now = Date.now()) => {
    const remaining = new Date(deadline).getTime() - now;
    if (!Number.isFinite(remaining) || remaining <= 0) return 'مهلت پایان یافته';
    const totalMinutes = Math.ceil(remaining / 60000);
    const days = Math.floor(totalMinutes / 1440);
    const hours = Math.floor((totalMinutes % 1440) / 60);
    const minutes = totalMinutes % 60;
    if (days) return `${days} روز و ${hours} ساعت باقی مانده`;
    if (hours) return `${hours} ساعت و ${minutes} دقیقه باقی مانده`;
    return `${minutes} دقیقه باقی مانده`;
};

export const makeIdempotencyKey = (prefix, attemptId, answerId) => {
    const randomPart = (typeof window !== 'undefined' && window.crypto?.randomUUID
        ? window.crypto.randomUUID().replaceAll('-', '')
        : `${Date.now()}${Math.random().toString(36).slice(2)}`).slice(0, 20);
    return `${prefix.slice(0, 8)}-${attemptId}-${answerId ?? 0}-${randomPart}`.slice(0, 64);
};

export const toFeedbackPage = (value) => Array.isArray(value)
    ? {count: value.length, next: null, previous: null, results: value}
    : {count: 0, next: null, previous: null, results: [], ...(value || {})};

export const getConflictCode = (error) => {
    if (error?.status !== 409) return '';
    return error?.code || error?.data?.detail || error?.normalized?.message || '';
};

